@if (isPhoneShell) {
    <!-- Tabs para teléfonos -->
    <ion-tabs>
        @if (showTabs) {
            <ion-tab-bar slot="bottom" class="gm-tab-bar" [class.gm-tab-bar--hidden]="!tabsVisible">
                @for (page of appPages; track page.route) {
                    <ion-tab-button
                        [tab]="page.route"
                        [routerLink]="['/' + page.url]"
                        routerLinkActive="tab-selected"
                        [routerLinkActiveOptions]="{ exact: true }"
                    >
                        <!-- el activo se expande en una píldora con ícono + nombre (ver .gm-tab-bar en global.scss) -->
                        <span class="gm-tab-indicator">
                            <ion-icon [name]="page.icon" aria-hidden="true"></ion-icon>
                            <ion-label class="gm-tab-label">{{ page.title | translate }}</ion-label>
                        </span>
                    </ion-tab-button>
                }
            </ion-tab-bar>
        }
    </ion-tabs>
} @else {
    <!--
      Botón para plegar el menú lateral — posición fija dentro del menú
      desplegado. Plegado, el menú queda como franja de íconos (.gm-menu-rail)
      y el botón para desplegarlo vive dentro de esa franja.
    -->
    @if (sideMenuOpen) {
        <ion-button
            fill="clear"
            class="gm-side-menu-toggle gm-side-menu-toggle--open"
            (click)="uiService.toggleSideMenu()"
            [attr.aria-label]="'NAV.HIDE_MENU' | translate"
        >
            <ion-icon slot="icon-only" name="hugeicons--sidebar-left-01"></ion-icon>
        </ion-button>
    }
    <!-- Menú lateral para tablet y desktop, togglable con uiService.toggleSideMenu() -->
    <ion-split-pane contentId="main-content" [when]="true">
        <ion-menu
            contentId="main-content"
            type="push"
            class="gm-desktop-menu gm-desktop-menu--rail"
            [class.gm-menu-collapsed]="!sideMenuOpen"
        >
            @if (sideMenuOpen) {
                <ion-content #menuContent class="ion-padding gm-menu-nav">
                    <img
                        src="assets/business/vertical/vertical-light.png"
                        alt="GetMarket Business"
                        class="ion-margin gm-menu-logo gm-theme-light"
                        (click)="home()"
                    />
                    <img
                        src="assets/business/vertical/vertical-dark.png"
                        alt="GetMarket Business"
                        class="ion-margin gm-menu-logo gm-theme-dark"
                        (click)="home()"
                    />
                    <ion-list>
                        @for (page of sideMenuTopPages; track page.route) {
                            <ion-menu-toggle auto-hide="false">
                                <ion-item
                                    lines="none"
                                    detail="false"
                                    [routerLink]="page.url"
                                    [class.selected]="isSelected(page)"
                                >
                                    <ion-icon slot="start" [name]="page.icon"></ion-icon>
                                    <ion-label>{{ page.title | translate }}</ion-label>
                                </ion-item>
                            </ion-menu-toggle>
                        }
                    </ion-list>

                    <!--
                      "Menú" es el único acordeón de nivel superior: todo lo de
                      menu.page.html (categorías + accesos) vive DENTRO de su
                      contenido, así se ve claramente que son hijos de Menú y no
                      ítems al mismo nivel que Ventas/Compras/Planificación.
                    -->
                    <ion-accordion-group
                        class="gm-menu-accordion"
                        [value]="gestionAccordionValue"
                        (ionChange)="onGestionAccordionChange($event)"
                    >
                        <ion-accordion value="menu" toggle-icon-slot="end">
                            <ion-menu-toggle auto-hide="false" slot="header">
                                <ion-item
                                    lines="none"
                                    detail="false"
                                    routerLink="menu"
                                    routerLinkActive="selected"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                >
                                    <ion-icon slot="start" name="hugeicons--more"></ion-icon>
                                    <ion-label>{{ 'NAV.MANAGEMENT' | translate }}</ion-label>
                                </ion-item>
                            </ion-menu-toggle>
                            <div slot="content" class="gm-submenu">
                                <!--
                                  Categorías desplegables (ion-accordion anidado, selección única):
                                  al navegar a un submenú, su categoría se abre y las demás se
                                  colapsan solas (ver syncOpenCategoryWithRoute) — el usuario también
                                  puede plegar/desplegar libremente para explorar.
                                -->
                                <ion-accordion-group
                                    class="gm-submenu-accordion"
                                    [value]="openSubCategory"
                                    (ionChange)="onSubCategoryChange($event)"
                                >
                                    @for (category of menuCategories; track category.value) {
                                        <ion-accordion [value]="category.value" toggle-icon-slot="end">
                                            <ion-item
                                                slot="header"
                                                lines="none"
                                                detail="false"
                                                [class.gm-category-active]="activeCategoryValue === category.value"
                                            >
                                                <ion-icon slot="start" [name]="category.icon"></ion-icon>
                                                <ion-label>{{ category.title | translate }}</ion-label>
                                            </ion-item>
                                            <ion-list slot="content" class="gm-submenu-list">
                                                @for (item of category.items; track item.route + '|' + (item.queryParams.type || '')) {
                                                    <ion-menu-toggle auto-hide="false">
                                                        <ion-item
                                                            lines="none"
                                                            detail="false"
                                                            [routerLink]="item.route"
                                                            [queryParams]="item.queryParams"
                                                            routerLinkActive="selected"
                                                            class="gm-submenu-item"
                                                        >
                                                            <ion-icon slot="start" [name]="item.icon"></ion-icon>
                                                            <ion-label>{{ item.title | translate }}</ion-label>
                                                            @if (badgeFor(item) > 0) {
                                                                <ion-badge slot="end" color="danger">{{ badgeFor(item) }}</ion-badge>
                                                            }
                                                        </ion-item>
                                                    </ion-menu-toggle>
                                                }
                                            </ion-list>
                                        </ion-accordion>
                                    }
                                </ion-accordion-group>
                            </div>
                        </ion-accordion>
                    </ion-accordion-group>

                </ion-content>
                <ion-footer class="gm-desktop-menu-footer">
                    <!--
                      Toolbar del pie (tema + notificaciones): va en el ion-footer y
                      no flotando sobre ion-content, así nunca tapa ítems del menú.
                    -->
                    <div class="gm-menu-toolbar" role="toolbar" [attr.aria-label]="'NAV.PREFERENCES_ARIA' | translate">
                        <!-- Cambio de tema (mismo ThemeService que el toggle de Perfil). Solo en el menú desplegado. -->
                        <button
                            type="button"
                            class="gm-module-icon gm-notifications-trigger"
                            [title]="(themeService.isDark ? 'THEME.TO_LIGHT' : 'THEME.TO_DARK') | translate"
                            [attr.aria-label]="(themeService.isDark ? 'THEME.TO_LIGHT' : 'THEME.TO_DARK') | translate"
                            [attr.aria-pressed]="themeService.isDark"
                            (click)="themeService.setDark(!themeService.isDark, $event)"
                        >
                            <!-- sol en amarillo (warning) en modo oscuro; la luna mantiene el color de marca del botón -->
                            <ion-icon
                                [name]="themeService.isDark ? 'sunny-outline' : 'moon-outline'"
                                [color]="themeService.isDark ? 'warning' : undefined"
                                aria-hidden="true"
                            ></ion-icon>
                        </button>
                        @if (showNotifications) {
                            <div class="gm-notifications-trigger-wrap">
                                <button
                                    id="notifications-trigger"
                                    type="button"
                                    class="gm-module-icon gm-notifications-trigger"
                                    [title]="'NAV.NOTIFICATIONS' | translate"
                                    [attr.aria-label]="'NAV.NOTIFICATIONS' | translate"
                                >
                                    <ion-icon name="notifications-outline" aria-hidden="true"></ion-icon>
                                </button>
                                @if (unreadNotificationsCount > 0) {
                                    <ion-badge color="danger" class="gm-notifications-badge">
                                        {{ unreadNotificationsCount }}
                                    </ion-badge>
                                }
                            </div>
                        }
                    </div>
                    @if (showNotifications) {
                        <ion-popover trigger="notifications-trigger" [dismissOnSelect]="true" side="top" alignment="end">
                            <ng-template>
                                <ng-container [ngTemplateOutlet]="notificationsList"></ng-container>
                            </ng-template>
                        </ion-popover>
                    }
                    <ion-menu-toggle auto-hide="false">
                        <ion-item
                            class="gm-logout-toggle"
                            lines="none"
                            detail="false"
                            button="true"
                            (click)="logoutFromMenu()"
                        >
                            <ion-icon slot="start" name="hugeicons--logout-02-stroke-rounded"></ion-icon>
                            <ion-label>{{ 'COMMON.LOGOUT' | translate }}</ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                </ion-footer>
            } @else {
                <!--
                  Menú plegado: franja angosta solo con íconos. Arriba la marca
                  (vuelve al inicio) y el botón para desplegar; luego las mismas
                  páginas y categorías del menú desplegado — una categoría no tiene
                  ruta propia, así que su ícono abre un popover al costado con sus
                  submenús, sin desplegar el menú.
                -->
                <ion-content class="gm-menu-rail">
                    <nav class="gm-rail-nav" [attr.aria-label]="'NAV.MAIN_MENU_ARIA' | translate">
                        <button type="button" class="gm-rail-brand" [title]="'NAV.HOME' | translate" [attr.aria-label]="'NAV.GO_HOME' | translate" (click)="home()">
                            <img src="assets/business/icon.png" alt="" class="gm-theme-light" />
                            <img src="assets/business/icon-dark.png" alt="" class="gm-theme-dark" />
                        </button>
                        <button
                            type="button"
                            class="gm-rail-button"
                            [title]="'NAV.SHOW_MENU' | translate"
                            [attr.aria-label]="'NAV.SHOW_MENU' | translate"
                            (click)="uiService.toggleSideMenu()"
                        >
                            <ion-icon name="hugeicons--sidebar-left-01" aria-hidden="true"></ion-icon>
                        </button>

                        @for (page of sideMenuTopPages; track page.route) {
                            <a
                                class="gm-rail-button"
                                [routerLink]="page.url"
                                [class.selected]="isSelected(page)"
                                [attr.aria-current]="isSelected(page) ? 'page' : null"
                                [title]="page.title | translate"
                                [attr.aria-label]="page.title | translate"
                            >
                                <ion-icon [name]="page.icon" aria-hidden="true"></ion-icon>
                            </a>
                        }

                        <hr class="gm-rail-divider" />

                        <a
                            class="gm-rail-button"
                            routerLink="menu"
                            routerLinkActive="selected"
                            ariaCurrentWhenActive="page"
                            [routerLinkActiveOptions]="{ exact: true }"
                            [title]="'NAV.MANAGEMENT' | translate"
                            [attr.aria-label]="'NAV.MANAGEMENT' | translate"
                        >
                            <ion-icon name="hugeicons--more" aria-hidden="true"></ion-icon>
                        </a>
                        @for (category of menuCategories; track category.value) {
                            <button
                                type="button"
                                class="gm-rail-button"
                                [id]="'rail-category-' + category.value"
                                [class.selected]="activeCategoryValue === category.value"
                                [title]="category.title | translate"
                                [attr.aria-label]="category.title | translate"
                                aria-haspopup="menu"
                            >
                                <ion-icon [name]="category.icon" aria-hidden="true"></ion-icon>
                            </button>
                            <ion-popover
                                class="gm-rail-popover"
                                [trigger]="'rail-category-' + category.value"
                                [dismissOnSelect]="true"
                                side="end"
                                alignment="start"
                            >
                                <ng-template>
                                    <ion-content>
                                        <ion-list lines="none" class="gm-submenu-list">
                                            <ion-list-header>{{ category.title | translate }}</ion-list-header>
                                            @for (item of category.items; track item.route + '|' + (item.queryParams.type || '')) {
                                                <ion-item
                                                    button
                                                    detail="false"
                                                    [routerLink]="item.route"
                                                    [queryParams]="item.queryParams"
                                                    routerLinkActive="selected"
                                                    class="gm-submenu-item"
                                                >
                                                    <ion-icon slot="start" [name]="item.icon"></ion-icon>
                                                    <ion-label>{{ item.title | translate }}</ion-label>
                                                    @if (badgeFor(item) > 0) {
                                                        <ion-badge slot="end" color="danger">{{ badgeFor(item) }}</ion-badge>
                                                    }
                                                </ion-item>
                                            }
                                        </ion-list>
                                    </ion-content>
                                </ng-template>
                            </ion-popover>
                        }

                        @if (showNotifications) {
                            <div class="gm-rail-bottom">
                                <div class="gm-notifications-trigger-wrap">
                                    <button
                                        id="notifications-trigger-rail"
                                        type="button"
                                        class="gm-rail-button"
                                        [title]="'NAV.NOTIFICATIONS' | translate"
                                        [attr.aria-label]="'NAV.NOTIFICATIONS' | translate"
                                    >
                                        <ion-icon name="notifications-outline" aria-hidden="true"></ion-icon>
                                    </button>
                                    @if (unreadNotificationsCount > 0) {
                                        <ion-badge color="danger" class="gm-notifications-badge">
                                            {{ unreadNotificationsCount }}
                                        </ion-badge>
                                    }
                                </div>
                            </div>
                        }
                    </nav>
                    @if (showNotifications) {
                        <ion-popover trigger="notifications-trigger-rail" [dismissOnSelect]="true" side="end" alignment="end">
                            <ng-template>
                                <ng-container [ngTemplateOutlet]="notificationsList"></ng-container>
                            </ng-template>
                        </ion-popover>
                    }
                </ion-content>
                <ion-footer class="gm-desktop-menu-footer gm-rail-footer">
                    <button
                        type="button"
                        class="gm-rail-button gm-rail-logout"
                        [title]="'COMMON.LOGOUT' | translate"
                        [attr.aria-label]="'COMMON.LOGOUT' | translate"
                        (click)="logoutFromMenu()"
                    >
                        <ion-icon name="hugeicons--logout-02-stroke-rounded" aria-hidden="true"></ion-icon>
                    </button>
                </ion-footer>
            }
        </ion-menu>
        <ion-router-outlet id="main-content"></ion-router-outlet>
    </ion-split-pane>

    <!-- Lista de notificaciones compartida por el menú desplegado y la franja plegada. -->
    <ng-template #notificationsList>
        <ion-content>
            <ion-list lines="none">
                <ion-list-header>{{ 'NAV.NOTIFICATIONS' | translate }}</ion-list-header>
                @for (notification of notifications; track notification.title) {
                    <ion-item button [class.gm-notification-unread]="!notification.read">
                        <ion-icon
                            slot="start"
                            name="notifications-outline"
                            [color]="notification.read ? 'medium' : 'primary'"
                        ></ion-icon>
                        <ion-label class="ion-text-wrap">
                            <p>{{ notification.title }}</p>
                            <p class="gm-notification-time">{{ notification.time }}</p>
                        </ion-label>
                    </ion-item>
                } @empty {
                    <ion-item lines="none">
                        <ion-label>{{ 'NAV.NO_NOTIFICATIONS' | translate }}</ion-label>
                    </ion-item>
                }
            </ion-list>
        </ion-content>
    </ng-template>
}
